import { Box, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";

interface MdaIncidentDateFilterProps {
  label?: string;
  from: Dayjs | null;
  to: Dayjs | null;
  onFromChange: (value: Dayjs | null) => void;
  onToChange: (value: Dayjs | null) => void;
}

const MdaIncidentDateFilter = ({
  label = "Incident Date",
  from,
  to,
  onFromChange,
  onToChange,
}: MdaIncidentDateFilterProps) => (
  <Stack spacing={0.8}>
    <Typography variant="caption" sx={{ color: "#24344d", fontWeight: 700 }}>
      {label}
    </Typography>
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      <DatePicker
        label="From"
        value={from}
        onChange={onFromChange}
        maxDate={to ?? undefined}
        slotProps={{
          textField: { size: "small", sx: { width: 170, maxWidth: "100%" } },
        }}
      />
      <DatePicker
        label="To"
        value={to}
        onChange={onToChange}
        minDate={from ?? undefined}
        slotProps={{
          textField: { size: "small", sx: { width: 170, maxWidth: "100%" } },
        }}
      />
    </Box>
  </Stack>
);

export default MdaIncidentDateFilter;
